import agent from "../api/agent";
import { NotificationEmail, NotificationEmailFormValues, PendingReminderSettings, UpdatePendingReminderSettings } from "../models/emailNotification";

export type NotificationEmailStore = {
    emails: NotificationEmail[];
    reminderSettings: PendingReminderSettings | null;
    loading: boolean;
    fetchEmails: () => Promise<void>;
    addEmail: (data: NotificationEmailFormValues) => Promise<void>;
    removeEmail: (id: string) => Promise<void>;
    fetchReminderSettings: () => Promise<void>;
    updateReminderSettings: (data: UpdatePendingReminderSettings) => Promise<void>;
    runReminderNow: () => Promise<void>;
};

export const createNotificationEmailStore = (set: any, _get: any): NotificationEmailStore => ({
    emails: [],
    reminderSettings: null,
    loading: false,

    fetchEmails: async () => {
        set((s: any) => ({ notificationEmailStore: { ...s.notificationEmailStore, loading: true } }));
        try {
            const res = await agent.NotificationEmails.list();
            set((s: any) => ({
                notificationEmailStore: { ...s.notificationEmailStore, emails: res || [], loading: false },
            }));
        } catch (e) {
            console.error(e);
            set((s: any) => ({ notificationEmailStore: { ...s.notificationEmailStore, loading: false } }));
        }
    },

    addEmail: async (data: NotificationEmailFormValues) => {
        await agent.NotificationEmails.add(data);
    },

    removeEmail: async (id: string) => {
        await agent.NotificationEmails.remove(id);
    },

    fetchReminderSettings: async () => {
        set((s: any) => ({ notificationEmailStore: { ...s.notificationEmailStore, loading: true } }));
        try {
            const settings = await agent.NotificationEmails.getReminderSettings();
            set((s: any) => ({
                notificationEmailStore: { ...s.notificationEmailStore, reminderSettings: settings, loading: false },
            }));
        } catch (e) {
            console.error(e);
            set((s: any) => ({ notificationEmailStore: { ...s.notificationEmailStore, loading: false } }));
        }
    },

    updateReminderSettings: async (data: UpdatePendingReminderSettings) => {
        const settings = await agent.NotificationEmails.updateReminderSettings(data);
        set((s: any) => ({ notificationEmailStore: { ...s.notificationEmailStore, reminderSettings: settings } }));
    },

    runReminderNow: async () => {
        await agent.NotificationEmails.runReminderNow();
        await (createNotificationEmailStore as any)(set, _get).fetchReminderSettings();
    },
});
